import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';

export const fetchPdf = async (
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  contractNo: number,
  billNumber: number,
  company: string,
): Promise<Blob> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const billDetails: AxiosResponse<Blob> = await API({
    method: 'post',
    url: `/v1/billPdf/${dataOwnerCustomerId}/${actingCustomerId}/${billNumber}/${company}`,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content,
      contractNo,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return billDetails.data;
};
